import * as Immutable from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';
import moment from 'moment';

const authState = Immutable.fromJS({
  user: {
    auto_generated: false,
    access_token: '',
    refresh_token: '',
    expires_in: 0,
    scope: '',
    token_type: '',
    user_id: null,
    isLoggedIn: false,
  },
  loading: false,
  validations: {
    validEmail: true
  },
  merchant: {
    new: false
  },
  modal: false,
  errors: []
});

function setState(state, newState) {
  return state.merge(newState);
}

export function auth(state = authState, action) {
  switch(action.type) {
    case ActionTypes.AUTO_PASSWORD:
      return setState(state, state.setIn(['user', 'auto_generated'], true));

    case ActionTypes.CLEAR_AUTH:
      return setState(state, state.set('user', authState.get('user')));

    case ActionTypes.AUTH_LOADING:
      return setState(state, state.set('loading', action.payload));

    case ActionTypes.LOG_IN:
      if (action.error) {
        return setState(state, state.set('errors', Immutable.fromJS(action.error)));
      }

      if (!action.auto) {
        // convert expires_in from seconds to unix timestamp
        action.payload.expires_in = moment().add((action.payload.expires_in / 86400), 'days').valueOf();
        localStorage.setItem('user', JSON.stringify(action.payload));
      }

      state = setState(state, state.set('errors', []));
      action.payload.isLoggedIn = true;
      return setState(state, state.set('user', Immutable.fromJS(action.payload)));

    case ActionTypes.RESET_LOGIN:
      state = setState(state, authState);
      return setState(state, state.set('modal', true));

    case ActionTypes.TOGGLE_AUTHENTICATION_MODAL:
      state = setState(state, state.setIn(['merchant', 'new'], action.creating));
      return setState(state, state.set('modal', !state.get('modal')));

    case ActionTypes.VALIDATE_EMAIL:
      if (action.payload.length > 0) {
        state = setState(state, state.setIn(['user', 'auto_generated'], action.payload[0].attributes.auto_generated));
        return setState(state, state.setIn(['validations', 'validEmail'], true));
      } else {
        return setState(state, state.setIn(['validations', 'validEmail'], false));
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js